import React from "react";

import { Col, Divider, Form, Input, Row } from "antd";

const CooperateProductPriceInformation = ({ cooperateEvent, handleChange }) => {
  return (
    <>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{ marginTop: 20 }}
      >
        <span className="product-register-box-title">공구 상품 가격 정보</span>
      </Row>
      <div
        className="product-register-border-box"
        wrap={false}
        style={{
          borderTop: 0,
          padding: "25px 25px 0",
          height: "fit-content",
        }}
      >
        <Form.Item
          className="product-register-form-input-wrap center-label"
          label="판매가"
          labelAlign="left"
          colon={false}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 8 }}
          required
        >
          <Input
            type="number"
            name="cooperate_original_price"
            value={cooperateEvent.cooperate_original_price}
            min={0}
            onChange={handleChange}
            addonAfter={<span className="product-price-label">원</span>}
          />
          <Col flex="none" className="product-price-help">
            *정가를 입력해주세요.
          </Col>
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="product-register-form-input-wrap center-label"
          label="할인률"
          labelAlign="left"
          colon={false}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 9 }}
          required
        >
          <Input
            type="number"
            name="cooperate_event_discount"
            value={cooperateEvent.cooperate_event_discount}
            onChange={handleChange}
            addonAfter={<span className="product-price-label">%</span>}
            min={0}
            max={100}
          />
          <Col flex="none" className="product-price-help">
            *할인 할 퍼센트를 입력해주세요.
          </Col>
        </Form.Item>
        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="product-register-form-input-wrap center-label"
          label="할인가"
          labelAlign="left"
          colon={false}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 11 }}
          required
        >
          <Input
            type="number"
            name="cooperate_event_price"
            value={cooperateEvent.cooperate_event_price}
            min={0}
            onChange={handleChange}
            addonAfter={<span className="product-price-label">원</span>}
          />
          <Col flex="none" className="product-price-help">
            *판매가를 넘지 않도록 해주세요.
          </Col>
        </Form.Item>

        <Divider className="product-register-form-input-divider" />
        <Form.Item
          className="product-register-form-input-wrap center-label"
          label="가격 설명란"
          labelAlign="left"
          colon={false}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 20 }}
          maxLength={10}
        >
          <Input
            type="text"
            name="cooperate_price_description"
            value={cooperateEvent.cooperate_price_description}
            onChange={handleChange}
            placeholder="1일 1,890원 | 1,000원 단위 이상일 경우 꼭 ','를 첨부해주세요!"
          />
          <Col flex="none" className="product-price-help">
            *10자 이내로 입력해주세요.
          </Col>
        </Form.Item>
      </div>
    </>
  );
};

export default CooperateProductPriceInformation;
